import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, ShieldCheck, Clock, Star, Package, MonitorSmartphone } from 'lucide-react';
import { heroImage, stats } from '../../data/mock';

export default function Hero() {
  return (
    <section id="home" className="relative min-h-[100vh] overflow-hidden bg-slate-900">
      <div className="absolute inset-0">
        <img src={heroImage} alt="Laboratorio GT Assistenza" className="w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950/95 via-slate-900/80 to-slate-900/40" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,rgba(14,165,233,0.18),transparent_55%)]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-40 pb-24 lg:pt-48 lg:pb-32">
        <div className="max-w-3xl">
          <div className="flex flex-wrap items-center gap-3">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 backdrop-blur-sm text-sky-200 text-xs font-semibold tracking-widest uppercase">
              <Star className="w-3.5 h-3.5" /> Centro assistenza dal 1996
            </div>
            <a
              href="https://www.dhl.com/it-it/home.html"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 pl-1.5 pr-4 py-1 rounded-full bg-yellow-400 hover:bg-yellow-300 text-slate-900 text-xs font-bold tracking-widest uppercase transition-colors shadow-md"
            >
              <span className="bg-white rounded-full p-1 flex items-center justify-center">
                <img src="/assets/dhl-logo.png" alt="DHL" className="h-4 w-auto object-contain" />
              </span>
              <Package className="w-3.5 h-3.5" /> Punto DHL ufficiale
            </a>
          </div>
          <h1 className="mt-6 text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.05] tracking-tight">
            Riparazioni rapide.<br />
            <span className="bg-gradient-to-r from-sky-300 to-cyan-200 bg-clip-text text-transparent">Tecnologia senza pensieri.</span>
          </h1>
          <p className="mt-6 text-lg md:text-xl text-slate-200/90 max-w-2xl leading-relaxed">
            Da quasi 30 anni a Biassono ripariamo PC, smartphone, TV e gestiamo l'IT delle aziende della Brianza. Diagnosi gratuita, preventivi trasparenti, garanzia su ogni intervento.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Button asChild size="lg" className="bg-sky-500 hover:bg-sky-400 text-white rounded-full px-7 h-12 text-base font-semibold shadow-lg shadow-sky-900/40">
              <a href="#contatti">Prenota una diagnosi <ArrowRight className="w-4 h-4 ml-1" /></a>
            </Button>
            <Button asChild variant="outline" size="lg" className="rounded-full px-7 h-12 text-base bg-transparent border-white/30 text-white hover:bg-white hover:text-slate-900">
              <a href="#servizi">Scopri i servizi</a>
            </Button>
            <Button asChild variant="outline" size="lg" className="rounded-full px-7 h-12 text-base bg-emerald-500/10 border-emerald-300/40 text-emerald-100 hover:bg-emerald-400 hover:text-white hover:border-emerald-400">
              <a href="https://www.iperiusremote.com/download.aspx" target="_blank" rel="noopener noreferrer">
                <MonitorSmartphone className="w-4 h-4 mr-1" /> Assistenza remota (Iperius)
              </a>
            </Button>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-6 text-slate-200/80">
            <div className="flex items-center gap-2 text-sm"><ShieldCheck className="w-4 h-4 text-sky-300" /> Garanzia 3 mesi</div>
            <div className="flex items-center gap-2 text-sm"><Clock className="w-4 h-4 text-sky-300" /> Intervento in 48h</div>
            <div className="flex items-center gap-2 text-sm"><Star className="w-4 h-4 text-sky-300" /> 4.9/5 su Google</div>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10 backdrop-blur-md">
          {stats.map((s) => (
            <div key={s.label} className="bg-slate-900/60 px-6 py-7">
              <div className="text-3xl md:text-4xl font-extrabold text-white tracking-tight">{s.value}</div>
              <div className="mt-1 text-xs md:text-sm text-slate-300 uppercase tracking-wider">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
